// extracted by mini-css-extract-plugin
module.exports = {"hstack":"HStack_hstack__vvEFq","grow":"HStack_grow__mMnY2","shrink":"HStack_shrink__XpDO0"};